import React from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { authLogout } from '../../../../actions/authenticationActions';

function Logout() {
  const history = useHistory();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(authLogout());
  }, []);
  return <div>{history.push('/')}</div>;
}

export default Logout;
